import ApiFactory from '../factories/ApiFactory'
import {serialize} from '../utilities/querySerialize'

export default {
  list (params) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/maintenancePayments?${serialize(params)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
  details (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/maintenancePayments/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        ).catch(e => reject(e))
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/maintenancePayments', payload).then(
        (success) => resolve(success.data),
        (error) => reject(error)
      )
    })
  },
  update (payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.put(`v1/maintenancePayments/${payload.id}`, payload).then(
        (success) => resolve(success.data),
        (error) => reject(error)
      )
    })
  },
  cancel (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/maintenancePayments/${id}/actions/cancel`).then(
        () => resolve(),
        (error) => reject(error)
      )
    })
  },
  confirm (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.post(`v1/maintenancePayments/${id}/actions/paymentReceived`).then(
        () => resolve(),
        (error) => reject(error)
      )
    })
  },
  getTransactions (id) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/maintenancePayments/${id}/actions/getTransactions`).then(
        (response) => resolve(response.data.data),
        (error) => reject(error)
      )
    })
  }
}
